import { render, staticRenderFns } from "./tableAdminPagination.vue?vue&type=template&id=6c7ddafc&scoped=true"
import script from "./tableAdminPagination.vue?vue&type=script&lang=js"
export * from "./tableAdminPagination.vue?vue&type=script&lang=js"
import style1 from "./tableAdminPagination.vue?vue&type=style&index=1&id=6c7ddafc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ddafc",
  null
  
)

export default component.exports